import { ContactDto } from '@/shared/lib/sj-orm/models/contact.dto';

export * from './contacts-helpers';

export const getContactFullName = (data: ContactDto) => {
  return data.name || data.lasName
    ? [data.name, data.lasName].filter((item) => Boolean(item)).join(' ')
    : '';
};
